import { SetValueConfig } from 'react-hook-form';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import { Button } from '@techem/ui-components';
import { SIZE } from 'baseui/button';
import ZipField from '../../HouseAddress/components/ZipField';
import CityField from '../../HouseAddress/components/CityField';
import HouseNumberField from '../../HouseAddress/components/HouseNumberField';
import StreetField from '../../HouseAddress/components/StreetField';

interface InvoiceAddressFormProps {
  formControl: any;
  errors: any;
  setValue: (
    name: 'street' | 'houseNr' | 'zip' | 'city',
    value: any,
    options?: SetValueConfig
  ) => void;
  onSubmit: (data: any, e?: React.BaseSyntheticEvent) => void;
}

const InvoiceAddressForm: React.FC<InvoiceAddressFormProps> = ({
  formControl,
  errors,
  setValue,
  onSubmit
}) => {
  const { t } = useTranslation();

  return (
    <form noValidate onSubmit={onSubmit}>
      <Row className="justify-content-center mt-4">
        <Col xs={10} lg={9}>
          <Row>
            <Col lg={7}>
              <Row>
                <Col lg={4}>
                  <ZipField formControl={formControl} errors={errors} setValue={setValue} />
                </Col>
                <Col lg={8}>
                  <CityField formControl={formControl} errors={errors} setValue={setValue} />
                </Col>
              </Row>
            </Col>
            <Col lg={5}>
              <Row>
                <Col lg={9}>
                  <StreetField formControl={formControl} errors={errors} setValue={setValue} />
                </Col>
                <Col lg={3}>
                  <HouseNumberField formControl={formControl} errors={errors} setValue={setValue} />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="justify-content-center py-5">
        <Col className="text-center col-auto">
          <Button size={SIZE.large} type="submit" additionalTestId="next">
            {t('nextBtnText')}
          </Button>
        </Col>
      </Row>
    </form>
  );
};

export default InvoiceAddressForm;
